import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import '../../services/GlobalVariables';
import axios from 'axios';

const API_URL = global.SET_API_URL + 'advanceSkip/';

const initialState = {
    eligible: [],
    skipList: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ''
};

export const getEligibleAdvances = createAsyncThunk('advSkip/eligible', async (payload, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'eligible', { params: payload });
        return result.data;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.error) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

export const getSkipList = createAsyncThunk('advSkip/list', async (payload, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'list', { params: payload });
        return result.data;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.error) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

export const addSkip = createAsyncThunk('advSkip/add', async (payload, thunkAPI) => {
    try {
        const result = await axios.post(API_URL, payload);
        return result.data;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.error) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

export const deleteSkip = createAsyncThunk('advSkip/delete', async (skipID, thunkAPI) => {
    try {
        const result = await axios.delete(API_URL + skipID);
        return result.data;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.error) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

export const advanceSkipSlice = createSlice({
    name: 'advSkip',
    initialState,
    reducers: {
        reset: (state) => {
            state.eligible = [];
            state.skipList = [];
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEligibleAdvances.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getEligibleAdvances.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.eligible = action.payload || [];
            })
            .addCase(getEligibleAdvances.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(getSkipList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getSkipList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.skipList = action.payload || [];
            })
            .addCase(getSkipList.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(addSkip.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(addSkip.fulfilled, (state) => {
                state.isLoading = false;
                state.isSuccess = true;
            })
            .addCase(addSkip.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(deleteSkip.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteSkip.fulfilled, (state) => {
                state.isLoading = false;
                state.isSuccess = true;
            })
            .addCase(deleteSkip.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            });
    }
});

export const { reset } = advanceSkipSlice.actions;

export default advanceSkipSlice.reducer;
